import { createTheme, ThemeOptions } from "@mui/material";
import { CssVarsThemeOptions } from "@mui/material/styles/createThemeWithVars";

const themeColor = "#800020";
const CommonThemeOptions: Omit<ThemeOptions, "components"> &
    Pick<CssVarsThemeOptions, "defaultColorScheme" | "colorSchemes" | "components"> & {
        cssVariables?:
            | boolean
            | Pick<
                  CssVarsThemeOptions,
                  | "colorSchemeSelector"
                  | "rootSelector"
                  | "disableCssColorScheme"
                  | "cssVarPrefix"
                  | "shouldSkipGeneratingVar"
              >;
    } = {
    palette: {
        primary: {
            main: themeColor,
        },
    },
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: 12,
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                body: {
                    padding: "2px 8px",
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    backgroundColor: themeColor,
                    color: "#fff",
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                action: {
                    alignItems: "center",
                    paddingTop: 0,
                },
                icon: {
                    alignItems: "center",
                },
            },
        },
    },
};

const LightTheme = createTheme({
    ...CommonThemeOptions,
    components: {
        ...CommonThemeOptions.components,
        MuiTableHead: {
            ...CommonThemeOptions.components?.MuiTableHead,
            styleOverrides: {
                ...CommonThemeOptions.components?.MuiTableHead?.styleOverrides,
                root: {
                    backgroundColor: "#e9ecef",
                },
            },
        },
        MuiTableFooter: {
            ...CommonThemeOptions.components?.MuiTableFooter,
            styleOverrides: {
                ...CommonThemeOptions.components?.MuiTableFooter?.styleOverrides,
                root: {
                    backgroundColor: "rgba(0,0,0,0.1)",
                },
            },
        },
    },
});

const DarkTheme = createTheme({
    ...CommonThemeOptions,
    palette: {
        ...CommonThemeOptions.palette,
        mode: "dark",
        background: {
            ...CommonThemeOptions.palette?.background,
            default: "#181a1b",
        },
    },
    components: {
        ...CommonThemeOptions.components,
        MuiTableHead: {
            ...CommonThemeOptions.components?.MuiTableHead,
            styleOverrides: {
                ...CommonThemeOptions.components?.MuiTableHead?.styleOverrides,
                root: {
                    backgroundColor: "#2c2c2c",
                    color: "#fff",
                },
            },
        },
        MuiTableFooter: {
            ...CommonThemeOptions.components?.MuiTableFooter,
            styleOverrides: {
                ...CommonThemeOptions.components?.MuiTableFooter?.styleOverrides,
                root: {
                    backgroundColor: "rgba(255,255,255,0.1)",
                },
            },
        },
        MuiButton: {
            ...CommonThemeOptions.components?.MuiButton,
            styleOverrides: {
                ...CommonThemeOptions.components?.MuiButton?.styleOverrides,
                outlined: {
                    color: "#ccc",
                    borderColor: "#ccc",
                },
            },
        },
    },
    typography: {
        ...CommonThemeOptions.typography,
        allVariants: {
            color: "#ccc",
        },
    },
});

export const Theme = {
    light: LightTheme,
    dark: DarkTheme,
};
